import { BaseRequestModel } from '../../base/base.request.model';

export class ValidateParentalControlPINRequestMessage {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  ValidateParentalControlPINRequestMessage!: ValidatePinRequestModel;
}
class ValidatePinRequestModel extends BaseRequestModel {
  parentalControlPin!: string;
}
